/*
 * @Author: caiqin.xie
 * @since: 2023-06-29 15:49:13
 * @lastTime: 2023-08-24 15:53:48
 * @LastEditors: caiqin.xie
 * @message: 服务门店-门店列表组件
 */
import React from "react";
import CarouselShopItem from "../../../components/CarouselShopItem";
import styles from "../../index.module.scss";
import { IShop } from "@/common/types";

interface IProps {
  shopList: IShop[]; // 门店列表
  allShopList: IShop[]; // 所有门店列表
  device: string;
}

const ServiceShopList = (props:IProps) => {
  const {shopList, allShopList, device} = props;
  const list = device === 'pc' ? shopList : allShopList;

  return (
    <div className={styles['store-list']}>
      {list.map((shop:IShop) => (
        <CarouselShopItem shop={shop} carousel={false} key={shop.id} />
      ))}
    </div>
  )
}

export default ServiceShopList;
